var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_warn_svg__clip0_2465_519)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 6.125,
    transform: "matrix(1 0 0 -1 7 7)",
    fill: "#FFB54C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.888V6.125",
    stroke: "#fff",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.525 4.287a.525.525 0 10-1.05 0 .525.525 0 001.05 0z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_warn_svg__clip0_2465_519"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(1 0 0 -1 0 14)",
    d: "M0 0h14v14H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_warn.7dda19c6.svg";
export { SvgTongyongWarn as ReactComponent };